import './App.css'
import Logo from './Images/logo.png'
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./Redux/Blockchain/blockchainActions";
import { fetchData } from "./Redux/Data/dataActions";


const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

function Header() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });
  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);
  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () =>{
     if(window.scrollY >= 80){
       setColorchange(true);
     }
     else{
       setColorchange(false);
     }
  };
  window.addEventListener('scroll', changeNavbarColor);
  return (
    <div>
      <header className={colorChange ? "header_wrap fixed-top nav-fixed" : "header_wrap fixed-top "}>
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg">
            <a
              className="navbar-brand page-scroll animation animated fadeInDown"
              href="#home_section"
              data-animation="fadeInDown"
              data-animation-delay="1s"
            >
              <img
                className="logo_light"
                src={Logo}
                width={100}
                height={100}
                alt="logo"
              />
              <img className="logo_dark" src={Logo} alt="logo" />
            </a>
            <button
              className="navbar-toggler animation animated fadeInDown"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              data-animation="fadeInDown"
              data-animation-delay="1.1s"
            >
              <span className="ion-android-menu"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav m-auto">
                <li
                  className="dropdown animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.1s"
                >
                  <a data-toggle="dropdown" className="nav-link active" href="#">
                    Home
                  </a>
                </li>
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.2s"
                >
                  <a className="nav-link page-scroll nav_item" href="#service">
                    Services
                  </a>
                </li>
                
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.4s"
                >
                  <a className="nav-link page-scroll nav_item" href="#token">
                    Token
                  </a>
                </li>
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.5s"
                >
                  <a className="nav-link page-scroll nav_item" href="#roadmap">
                    Road Map
                  </a>
                </li>
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.6s"
                >
                  <a className="nav-link page-scroll nav_item" href="#team">
                    Team
                  </a>
                </li>
               
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.8s"
                >
                  <a className="nav-link page-scroll nav_item" href="#contact">
                    Contact
                  </a>
                </li>
              </ul>
              <ul className="navbar-nav nav_btn align-items-center">
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="1.9s"
                >
                  <div className="lng_dropdown">
                    
                    <div>
                      <div className="ddTitle borderRadiusTp">
                        <span className="divider"></span>
                        <span className="ddTitleText " id="lng_select_title">
                          <span
                            className="description"
                            style={{ display: 'none' }}
                          ></span>
                        </span>
                      </div>
                      <input
                        id="lng_select_titleText"
                        type="text"
                        autocomplete="off"
                        className="text shadow borderRadius"
                        style={{ display: 'none' }}
                      />
                      <div
                        className="ddChild ddchild_ border shadow"
                        id="lng_select_child"
                        style={{
                          zIndex: 9999,
                          display: 'none',
                          position: 'absolute',
                        }}
                      >
                        <ul>
                          <li className="enabled _msddli_ selected" title="English">
                            <div className="clear"></div>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  className="animation animated fadeInDown"
                  data-animation="fadeInDown"
                  data-animation-delay="2s"
                >
                   <h9
                      style={{
                        textAlign: "left",
                        color: "orange",
                      }}
                    >  &zwnj; 
                      {blockchain.errorMsg} 
                    </h9>
                  <a
                    className="btn btn-default btn-radius nav_item"
                  >
                    {blockchain.account === "" ||
                  blockchain.smartContract === null ? (<div onClick={(e) => {
                    e.preventDefault();
                    dispatch(connect());
                    getData();
                  }}>Connect Wallet</div>) : (<div>{truncate(blockchain.account, 10)}</div>)}
                    
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
      
    </div>
  )
}

export default Header
